<div class="w-full bg-white">

  <!-- FIXED HEADER -->
  <div class="bg-white fixed top-0 inset-x-0 z-10">
    <app-invoice-gst-header></app-invoice-gst-header>
  </div>

  <!-- PAGE CONTENT (outside fixed header) -->
  <div class="pt-14 md:pt-16 lg:pt-20">
    <router-outlet></router-outlet>
  </div>
</div>
